import type { LayerState } from '@vitals/shared';
import { boroughDetails, validBoroughSummary } from './boroughDetails.js';
import { activeTrains, type VitalDef } from './vitals.js';

export const subwayVital: VitalDef = {
  id: 'subway',
  layerId: 'subway',
  select: (state: LayerState | undefined) => {
    const trains = activeTrains(state);
    const down = trains === null;
    const stale = state?.status === 'stale';
    const summary = state?.summary;
    const hasBreakdown = !down
      && summary != null
      && validBoroughSummary(summary)
      && summary.count === trains;

    return {
      value: down ? '—' : trains.toLocaleString('en-US'),
      label: 'subway trains',
      down,
      stale,
      ...(hasBreakdown && {
        detailTitle: 'Subway trains by borough',
        details: boroughDetails(summary),
      }),
    };
  },
};
